var exports = {
  "l7": "RefSelectorOverlayBtn__KrS-QJ",
  "Oe": "RefSelectorOverlayContainer__do_QsK",
  "Tl": "RefSelectorBtnTextContainer__U9K7hH",
  "kP": "RefSelectorText__DKi677",
};

module.exports = exports;
